import apiConfig from '@/config/apiConfig';
import { apiBaseURL, toastifyType } from '@/constants';
import { addTost } from './toastAction';

export const getAllSidebarInfo = ({ setLoading }) => async (dispatch) => {
    setLoading && setLoading(true)
    try {
        const response = await apiConfig.get(`${apiBaseURL.FEEDS}/sidebar-menu`);
        setLoading && setLoading(false);
        return response
    } catch (error) {
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}